module.exports = __webpack_public_path__ + "img/eu.8c8d8b8e.svg";